module.exports = __webpack_public_path__ + "static/media/0110_IMG_LE_SOL_66_PELER.51198b7d.png";